import angular from 'angular'
import './user_segmentation.service'
import './manager/manager.controller'
import moment from 'moment-timezone'
import './user_segmentation.scss'
angular
  .module('admin.user_segmentation', [
    'admin.user_segmentation.manager',
    'admin.user_segmentation.service',
  ])
  .controller('UserSegmentationCtrl', UserSegmentationCtrl)

/** @ngInject */
function UserSegmentationCtrl(
  $scope,
  $state,
  $stateParams,
  UsersService,
  UserSegmentationService,
  CsvService,
  ScheduledMessageAppService,
  UploadService,
) {
  var vm = this
  vm.items = []
  vm.itemsArchived = []
  vm.users = []
  vm.msgFilter = 'You need to filter first'

  vm.sortType = 'id-desc'
  vm.sortReverse = false
  vm.sortType2 = 'id-desc'
  vm.sortReverse2 = false

  vm.types = [
    {
      id: 0,
      t: 'All',
    },
    {
      id: 2,
      t: 'Bundle',
    },
    {
      id: 1,
      t: 'Product / Deposit',
    },
    {
      id: 6,
      t: 'User',
    },
    {
      id: 3,
      t: 'Set',
    },
    {
      id: 4,
      t: 'Channel',
    },
    {
      id: 5,
      t: 'Promo',
    },
    {
      id: 7,
      t: 'A/B Testing',
    },
    {
      id: 8,
      t: 'And Segment',
    },
    {
      id: 9,
      t: 'Xor Segment',
    },
    {
      id: 10,
      t: 'Not Segment',
    },
    {
      id: 11,
      t: 'Exclude Segment',
    },
    {
      id: 13,
      t: 'Listing',
    },
    {
      id: 14,
      t: 'Fyber',
    },
    {
      id: 15,
      t: 'Coin Wallet',
    },
    {
      id: 16,
      t: 'Coin Claim',
    },
    {
      id: 17,
      t: 'Collection Size',
    },
    {
      id: 18,
      t: 'Collectible Ownership',
    },
    {
      id: 19,
      t: 'Collection Value',
    },
    {
      id: 20,
      t: 'Or Segment',
    },
    {
      id: 21,
      t: 'Region',
    },
    {
      id: 22,
      t: 'Language',
    },
    {
      id: 23,
      t: 'Coupon',
    },
    {
      id: 24,
      t: 'User Notification Preference',
    },
    {
      id: 25,
      t: 'Set Waitlist',
    },
    {
      id: 28,
      t: 'Channel Waitlist',
    },
    {
      id: 26,
      t: 'User Sign-in',
    },
    {
      id: 27,
      t: 'Burn',
    },
    {
      id: 28,
      t: 'Channel Waitlist',
    },
    {
      id: 29,
      t: 'Drop Waitlist',
    },
    {
      id: 30,
      t: 'User Status',
    },
  ]

  vm.notificationMethod = [
    {
      id: 1,
      name: 'Email',
    },
    {
      id: 2,
      name: 'Push',
    },
    {
      id: 3,
      name: 'In App',
    },
    {
      id: 4,
      name: 'Inbox',
    },
    {
      id: 5,
      name: 'SMS',
    },
  ]

  vm.notificationType = [
    {
      id: 4,
      name: 'At Mention',
      group: 'My Connections',
    },
    {
      id: 5,
      name: 'New Follower',
      group: 'My Connections',
    },
    {
      id: 6,
      name: 'Storyboard Liked',
      group: 'My Connections',
    },
    {
      id: 9,
      name: 'Chat Message',
      group: 'My Connections',
    },
    {
      id: 1,
      name: 'Listing Sold',
      group: 'My Collection Activity',
    },
    {
      id: 3,
      name: 'Print Received',
      group: 'My Collection Activity',
    },
    {
      id: 7,
      name: 'Wishlist Item Listed',
      group: 'My Collection Activity',
    },
    {
      id: 8,
      name: 'Wishlist Inquiry',
      group: 'My Collection Activity',
    },
    {
      id: 13,
      name: 'This Week on Collectible',
      group: 'Marketing',
    },
    {
      id: 14,
      name: 'Collectible Newsletter',
      group: 'Marketing',
    },
    {
      id: 20,
      name: 'Brand Revival',
      group: 'Marketing',
    },
    {
      id: 15,
      name: 'Free Pack',
      group: 'Marketing',
    },
    {
      id: 16,
      name: 'Flash Pack',
      group: 'Marketing',
    },
    {
      id: 44,
      name: 'All Collections',
      group: 'Drops',
    },
    {
      id: 45,
      name: 'Collection Recommendations',
      group: 'Drops',
    },
    {
      id: 46,
      name: 'Collections I Own',
      group: 'Drops',
    },
  ]

  vm.notificationType = _.orderBy(vm.notificationType, ['group', 'name'], ['asc', 'asc'])

  vm.albumTypes = [
    {
      id: 'channel',
      name: 'Channel',
    },
    {
      id: 'sets',
      name: 'Sets',
    },
    {
      id: 'awards',
      name: 'Awards',
    },
  ]

  vm.loginMethods = [
    {
      id: 1,
      name: 'Credentials',
    },
    {
      id: 2,
      name: 'Google',
    },
    {
      id: 3,
      name: 'Facebook',
    },
    {
      id: 4,
      name: 'Apple',
    },
    {
      id: 5,
      name: 'Crypto',
    },
  ]

  vm.stores = [
    {
      id: 1,
      name: 'App Store',
    },
    {
      id: 2,
      name: 'Play Store',
    },
    {
      id: 3,
      name: 'Stripe',
    },
  ]

  vm.typeActive = vm.types[0].id
  vm.typeArchived = vm.types[0].id

  vm.totalUsers = 0
  vm.usersPerPage = 15
  vm.oldPage = 0
  vm.currentPage = 15
  vm.first = true
  vm.totalItems = 0
  vm.pagination = {
    current: 1,
  }

  vm.totalUsers1 = 0
  vm.usersPerPage1 = 15
  vm.oldPage1 = 0
  vm.currentPage1 = 15
  vm.first1 = true
  vm.totalItems1 = 0
  vm.pagination1 = {
    current: 1,
  }

  vm.totalUsers2 = 0
  vm.usersPerPage2 = 15
  vm.oldPage2 = 0
  vm.currentPage2 = 15
  vm.first2 = true
  vm.totalItems2 = 0
  vm.pagination2 = {
    current: 1,
  }

  vm.totalUsers3 = 0
  vm.usersPerPage3 = 15
  vm.oldPage3 = 0
  vm.currentPage3 = 15
  vm.first3 = true
  vm.totalItems3 = 0
  vm.pagination3 = {
    current: 1,
  }

  vm.totalUsers4 = 0
  vm.usersPerPage4 = 15
  vm.oldPage4 = 0
  vm.currentPage4 = 15
  vm.first4 = true
  vm.totalItems4 = 0
  vm.pagination4 = {
    current: 1,
  }

  function resetPage() {
    vm.totalUsers = 0
    vm.usersPerPage = 15
    vm.oldPage = 0
    vm.currentPage = 15
    vm.first = true
    vm.totalItems = 0
    vm.pagination = {
      current: 1,
    }
  }

  function resetPage1() {
    vm.totalUsers1 = 0
    vm.usersPerPage1 = 15
    vm.oldPage1 = 0
    vm.currentPage1 = 15
    vm.first1 = true
    vm.totalItems1 = 0
    vm.pagination1 = {
      current: 1,
    }
  }

  function resetPage2() {
    vm.totalUsers2 = 0
    vm.usersPerPage2 = 15
    vm.oldPage2 = 0
    vm.currentPage2 = 15
    vm.first2 = true
    vm.totalItems2 = 0
    vm.pagination2 = {
      current: 1,
    }
  }

  function resetPage3() {
    vm.totalUsers3 = 0
    vm.usersPerPage3 = 15
    vm.oldPage3 = 0
    vm.currentPage3 = 15
    vm.first3 = true
    vm.totalItems3 = 0
    vm.pagination3 = {
      current: 1,
    }
  }

  loadNotArchived(1)
  loadArchived(1)

  var tab = localStorage.getItem('user_segmentation_tab')
  if (tab !== null) {
    if (tab === 'manager') {
      $('#list2').removeClass('active')
      $('#manager2').removeClass('active')
      $('#snapshot').removeClass('active')
      $('#snapshottab').removeClass('active')
      $('#manager').addClass('active')
      $('#managertab').addClass('active')
    } else if (tab === 'manager2') {
      $('#list2').removeClass('active')
      $('#manager').removeClass('active')
      $('#snapshot').removeClass('active')
      $('#snapshottab').removeClass('active')
      $('#manager2').addClass('active')
      $('#managertab2').addClass('active')
    } else if (tab === 'snapshot') {
      $('#list2').removeClass('active')
      $('#manager').removeClass('active')
      $('#manager2').removeClass('active')
      $('#managertab2').removeClass('active')
      $('#managertab2').removeClass('active')
      $('#snapshot').addClass('active')
      $('#snapshottab').addClass('active')
    } else {
      $('#manager').removeClass('active')
      $('#manager2').removeClass('active')
      $('#snapshot').removeClass('active')
      $('#snapshottab').removeClass('active')
      $('#list2').addClass('active')
      $('#listtab').addClass('active')
    }
  } else {
    $('#manager').addClass('active')
    $('#managertab').addClass('active')
  }

  vm.tabManager = function () {
    $('#list2').removeClass('active')
    $('#manager2').removeClass('active')
    $('#snapshot').removeClass('active')
    $('#manager').addClass('active')
    localStorage.setItem('user_segmentation_tab', 'manager')
  }

  vm.tabManagerArchived = function () {
    $('#list2').removeClass('active')
    $('#manager').removeClass('active')
    $('#snapshot').removeClass('active')
    $('#manager2').addClass('active')
    localStorage.setItem('user_segmentation_tab', 'manager2')
  }

  vm.tabList = function () {
    $('#manager').removeClass('active')
    $('#manager2').removeClass('active')
    $('#snapshot').removeClass('active')
    $('#list2').addClass('active')
    localStorage.setItem('user_segmentation_tab', 'list')
  }

  vm.tabSnapshot = function () {
    $('#manager').removeClass('active')
    $('#manager2').removeClass('active')
    $('#list2').removeClass('active')
    $('#snapshot').addClass('active')
    localStorage.setItem('user_segmentation_tab', 'snapshot')
  }

  function reloadPaginationSearchUser() {
    vm.totalItemsSearchUser = 0
    vm.oldPageSearchUser = 0
    vm.currentPageSearchUser = 25
    vm.firstSearchUser = true
    vm.totalItemsSearchUser = 0
    vm.paginationSearchUser = {
      current: 1,
    }
  }

  UserSegmentationService.listAll().then(function (result) {
    vm.allItems = result.results
  })

  var oldSortType, oldSortType2

  function load(pageNumber, archived) {
    if (archived) {
      if (pageNumber === 1) {
        vm.pagination1.current = 1
      }
      if (!vm.first1) {
        vm.currentPage1 = pageNumber * 15
        vm.oldPage1 = vm.currentPage1 - 15
      } else {
        vm.first1 = false
      }
    } else {
      if (pageNumber === 1) {
        vm.pagination.current = 1
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 15
        vm.oldPage = vm.currentPage - 15
      } else {
        vm.first = false
      }
    }

    if (vm.searchActive === null || vm.searchActive === undefined) {
      vm.searchActive = ''
    }

    if (vm.searchArchived === null || vm.searchArchived === undefined) {
      vm.searchArchived = ''
    }

    oldSortType = angular.copy(vm.sortType)
    UserSegmentationService.listActive(
      vm.oldPage,
      15,
      vm.typeActive,
      vm.searchActive,
      vm.sortType,
    ).then(function (result) {
      var items = result.results
      if (vm.totalItems === 0) {
        vm.totalItems = result.ct
      }

      for (var i = 0; i < items.length; i++) {
        var element = items[i]
        var rule = JSON.parse(element.rule)
        var rulet = ''
        if (element.k === 1) {
          if (rule['pr-k'] === 4) {
            rulet += 'Cash Deposit - '
          } else {
            rulet += 'Coin Products - '
          }
          if (rule.all && rule['id-p'] !== undefined) {
            var idsConcat = ''
            rule['id-p'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += idsConcat + ' - '
          } else if (!rule.all && rule['id-p'] !== undefined) {
            var idsConcat = ''
            rule['id-p'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += idsConcat + ' - '
          }

          if (rule['id-p'] === undefined) {
            if (rule['price-min'] !== undefined) {
              rulet += 'Price Min $' + rule['price-min'] + ', '
            }
            if (rule['price-max'] !== undefined) {
              rulet += 'Price Max $' + rule['price-max'] + ' - '
            }
          }

          if (rule['spent-min'] !== undefined) {
            rulet += 'Spent Min $' + rule['spent-min'] + ', '
          }
          if (rule['spent-max'] !== undefined) {
            rulet += 'Spent Max $' + rule['spent-max'] + ' - '
          }

          if (rule['cp-min'] !== undefined) {
            rulet += 'Purchased Min ' + rule['cp-min'] + ', '
          }
          if (rule['cp-max'] !== undefined) {
            rulet += 'Purchased Max ' + rule['cp-max'] + ' - '
          }
          if (rule['store'] !== undefined) {
            var idsConcat = ''
            rule['store'].map(function (item) {
              var store = _.find(vm.stores, function (o) {
                return o.id === item
              })
              idsConcat += store.name + ', '
            })

            rulet += 'Store: ' + idsConcat
          }

          items[i].type = 'Product'
        } else if (element.k === 2) {
          rulet += 'Collectible Bundles - '
          if (rule.all && rule['id-b'] !== undefined) {
            var idsConcat = ''
            rule['id-b'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += idsConcat + ' - '
          } else if (!rule.all && rule['id-b'] !== undefined) {
            var idsConcat = ''
            rule['id-b'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += idsConcat + ' - '
          }

          if (rule['cbp-min'] !== undefined) {
            rulet += 'Purchase count Min ' + rule['cbp-min'] + ', '
          }
          if (rule['cbp-max'] !== undefined) {
            rulet += 'Purchase count Max ' + rule['cbp-max'] + ' - '
          }

          if (rule['spent-min'] !== undefined) {
            rulet += 'Total spent Min ' + rule['spent-min'] + ', '
          }
          if (rule['spent-max'] !== undefined) {
            rulet += 'Total spent Max ' + rule['spent-max'] + ' - '
          }

          if (rule['spent-min-cash'] !== undefined) {
            rulet += 'Total spent cash Min ' + rule['spent-min-cash'] + ', '
          }
          if (rule['spent-max-cash'] !== undefined) {
            rulet += 'Total spent cash Max ' + rule['spent-max-cash'] + ' - '
          }

          if (rule['inc-free'] !== undefined) {
            rulet += 'Include free: yes -'
          }

          items[i].type = 'Bundle'
        } else if (element.k === 3) {
          rulet += 'Sets - '

          if (rule.all && rule['id-s'] !== undefined) {
            var idsConcat = ''
            rule['id-s'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += idsConcat + ' - '
          } else if (!rule.all && rule['id-s'] !== undefined) {
            var idsConcat = ''
            rule['id-s'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += idsConcat + ' - '
          }
          if (rule['r-val-min'] !== undefined) {
            rulet += 'Value Rank Min ' + rule['r-val-min'] + ', '
          }
          if (rule['r-val-max'] !== undefined) {
            rulet += 'Value Rank Max ' + rule['r-val-max'] + ' - '
          }

          if (rule['r-comp-min'] !== undefined) {
            rulet += 'Comp Rank Min ' + rule['r-comp-min'] + ', '
          }
          if (rule['r-comp-max'] !== undefined) {
            rulet += 'Comp Rank Max ' + rule['r-comp-max'] + ' - '
          }

          items[i].type = 'Set'
        } else if (element.k === 4) {
          rulet += 'Channels - '

          if (rule['id-ch'] !== undefined) {
            rulet += rule['id-ch'] + ' - '
          }
          if (rule['k-album'] !== undefined) {
            rulet += 'Album Type ' + rule['k-album'] + ', '
          }
          if (rule['r-val-min'] !== undefined) {
            rulet += 'Value Rank Min ' + rule['r-val-min'] + ', '
          }
          if (rule['r-val-max'] !== undefined) {
            rulet += 'Value Rank Max ' + rule['r-val-max'] + ' - '
          }
        } else if (element.k === 5) {
          rulet += 'Promo ID ' + rule['id-promo']
          items[i].type = 'Promo'
        } else if (element.k === 6) {
          rulet += 'Users ID ' + rule['id-u']
          items[i].type = 'User'
        } else if (element.k === 7) {
          rulet += 'Cohort Count - ' + rule['c-cohort'] + ', '
          rulet += 'Cohort To Match - ' + rule.ctm
          items[i].type = 'A/B Testing'
        } else if (element.k === 8) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'And Segment IDs - ' + idsConcat
          items[i].type = 'And Segment'
        } else if (element.k === 9) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Xor Segment IDs - ' + idsConcat
          items[i].type = 'Xor Segment'
        } else if (element.k === 10) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Not Segment IDs - ' + idsConcat
          items[i].type = 'Not Segment'
        } else if (element.k === 11) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Exclude Segment IDs - ' + idsConcat
          rulet += 'Starting Segment ID - ' + rule['id-sseg'] + ', '
          items[i].type = 'Exclude Segment'
        } else if (element.k === 13) {
          if (rule['pur'] !== undefined) {
            rulet += 'Listings Purchase ' + (rule['pur'] ? 'Yes' : 'No') + ', '
          }
          if (rule['lc-min'] !== undefined) {
            rulet += 'Listing Count Min ' + rule['lc-min'] + ', '
          }
          if (rule['lc-max'] !== undefined) {
            rulet += 'Listing Count Max ' + rule['lc-max'] + ' - '
          }
          if (rule['sc-min'] !== undefined) {
            rulet += 'Sales Count Min ' + rule['sc-min'] + ', '
          }
          if (rule['sc-max'] !== undefined) {
            rulet += 'Sale Count Max ' + rule['sc-max'] + ' - '
          }
          if (rule['sa-min'] !== undefined) {
            rulet += 'Sales Amount Min ' + rule['sa-min'] + ', '
          }
          if (rule['sa-max'] !== undefined) {
            rulet += 'Sale Amount Max ' + rule['sa-max'] + ' - '
          }
          if (rule['id-ch'] !== undefined) {
            rulet += 'Channel ID ' + rule['id-ch'] + ' - '
          }
          if (rule['id-s'] !== undefined) {
            rulet += 'Set ID ' + rule['id-s'] + ' - '
          }
          items[i].type = 'Listing'
        } else if (element.k === 14) {
          if (rule['ce-min'] !== undefined) {
            rulet += 'Coins Earned Min ' + rule['ce-min'] + ', '
          }
          if (rule['ce-max'] !== undefined) {
            rulet += 'Coins Earned Max ' + rule['ce-max'] + ' - '
          }
          if (rule['ec-min'] !== undefined) {
            rulet += 'Earned Count Min ' + rule['ec-min'] + ', '
          }
          if (rule['ec-max'] !== undefined) {
            rulet += 'Earned Count Max ' + rule['ec-max'] + ' - '
          }
          items[i].type = 'Fyber'
        } else if (element.k === 15) {
          if (rule['c-min'] !== undefined) {
            rulet += 'Coins Min ' + rule['c-min'] + ', '
          }
          if (rule['c-max'] !== undefined) {
            rulet += 'Coins Max ' + rule['c-max']
          }
          items[i].type = 'Coin Wallet'
        } else if (element.k === 16) {
          if (rule['cl-min'] !== undefined) {
            rulet += 'Claims Min ' + rule['cl-min'] + ', '
          }
          if (rule['cl-max'] !== undefined) {
            rulet += 'Claims Max ' + rule['cl-max']
          }
          if (rule['c-min'] !== undefined) {
            rulet += 'Coins Min ' + rule['c-min'] + ', '
          }
          if (rule['c-max'] !== undefined) {
            rulet += 'Coins Max ' + rule['c-max']
          }
          items[i].type = 'Coin Claim'
        } else if (element.k === 17) {
          if (rule['cpo-min'] !== undefined) {
            rulet += 'Prints Min ' + rule['cpo-min'] + ', '
          }
          if (rule['cpo-max'] !== undefined) {
            rulet += 'Prints Max ' + rule['cpo-max']
          }
          if (rule['cqo-min'] !== undefined) {
            rulet += 'Collectibles Min ' + rule['cqo-min'] + ', '
          }
          if (rule['cqo-max'] !== undefined) {
            rulet += 'Collectibles Max ' + rule['cqo-max']
          }
          items[i].type = 'Collection Size'
        } else if (element.k === 18) {
          var idsConcat = ''
          rule['id-q'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Owns Collectible IDs - ' + idsConcat
          if (rule['all'] !== undefined) {
            rulet += ' All - ' + rule['all']
          }
          if (rule['r-val-min'] !== undefined) {
            rulet += ' Value Rank min ' + rule['r-val-min'] + ', '
          }
          if (rule['r-val-max'] !== undefined) {
            rulet += ' Value Rank max ' + rule['r-val-max'] + ' - '
          }
          items[i].type = 'Collectible Ownership'
        } else if (element.k === 19) {
          if (rule['val-min'] !== undefined) {
            rulet += ' Value Min ' + rule['val-min'] + ', '
          }
          if (rule['val-max'] !== undefined) {
            rulet += ' Value Max ' + rule['val-max']
          }
          items[i].type = 'Collection Value'
        } else if (element.k === 20) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Or Segment IDs - ' + idsConcat
          items[i].type = 'Or Segment'
        } else if (element.k === 21) {
          if (rule['id-ch'] !== undefined) {
            rulet += 'Channel ID ' + rule['id-ch']
          }
          if (rule['lcs'] !== undefined) {
            rulet += 'Locales ' + rule['lcs']
          }
          items[i].type = 'Region'
        } else if (element.k === 22) {
          if (rule['lang'] && rule['lang'].length > 0) {
            rulet += 'Languages ' + rule['lang']
          }
          if (rule['comm'] && rule['comm'].length > 0) {
            rulet += 'Communities ' + rule['comm']
          }
          items[i].type = 'Language'
        } else if (element.k === 23) {
          rulet += 'Coupon - '
          if (rule['id-cpn']) {
            rulet += 'Coupon IDs ' + rule['id-cpn'] + ', '
          }

          if (rule['cc-min']) {
            rulet += 'Count Min ' + rule['cc-min'] + ', '
          }
          if (rule['cc-max']) {
            rulet += 'Count Max ' + rule['cc-max']
          }
          items[i].type = 'Coupon'
        } else if (element.k === 24) {
          rulet += 'User Notification Preferences - '
          if (rule['met']) {
            var met = _.find(vm.notificationMethod, function (o) {
              return o.id === rule['met']
            })

            rulet += 'Method ' + met.name + ', '
          }
          if (rule['k']) {
            var kType = _.find(vm.notificationType, function (o) {
              return o.id === rule['k']
            })
            rulet += 'Type ' + kType.name + ', '
          }
          if (rule['enabled']) {
            rulet += 'Enabled ' + rule['enabled'] ? 'Yes' : 'No'
          }
          items[i].type = 'User Notification Preference'
        } else if (element.k === 25) {
          rulet += 'Set Waitlist - '
          if (rule['id-s']) {
            rulet += 'Set Ids ' + rule['id-s'] + ', '
          }
          if (rule['all']) {
            rulet += 'All ' + rule['all'] ? 'All' : 'Any'
          }
          items[i].type = 'Set Waitlist'
        } else if (element.k === 26) {
          rulet += 'User Sign-in - '
          if (rule['cc-min']) {
            rulet += 'Count Min ' + rule['cc-min'] + ', '
          }
          if (rule['cc-max']) {
            rulet += 'Count Max ' + rule['cc-max'] + ', '
          }
          if (rule['days']) {
            rulet += 'Days ' + (rule['days'] ? 'yes' : 'no') + ', '
          }
          if (rule['m']) {
            var m = _.join(
              _.flatMap(
                _.filter(vm.loginMethods, function (o) {
                  return rule['m'].indexOf(o.id) !== -1
                }),
                'name',
              ),
              ', ',
            )

            if (m) {
              rulet += 'Method ' + m + ', '
            }
          }
          if (rule['all']) {
            rulet += 'All ' + rule['all'] ? 'All' : 'Any'
          }
          items[i].type = 'User Sign-in'
        } else if (element.k === 27) {
          rulet += 'Burn - '

          if (rule['cc-min']) {
            rulet += 'Count Min ' + rule['cc-min'] + ', '
          }
          if (rule['cc-max']) {
            rulet += 'Count Max ' + rule['cc-max'] + ', '
          }
          if (rule['id-s']) {
            rulet += 'Set Id ' + rule['id-s'] + ', '
          }

          if (rule['id-q']) {
            var idsConcat = ''
            rule['id-q'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Collectible IDs - ' + idsConcat
          }
          if (rule['id-shiny']) {
            var idsConcat = ''
            rule['id-shiny'].map(function (item) {
              idsConcat += item + ','
            })
            rulet += 'Shiny IDs - ' + idsConcat
          }

          rulet += 'All' + rule['all'] ? ' All ' : ' Any '
          items[i].type = 'Burn'
        } else if (element.k === 28) {
          rulet += 'Channel Waitlist - '
          if (rule['id-ch']) {
            rulet += 'Chnannel Ids ' + rule['id-ch'] + ', '
          }
          if (rule['all']) {
            rulet += 'All ' + rule['all'] ? 'All' : 'Any'
          }
          items[i].type = 'Channel Waitlist'
        } else if (element.k === 29) {
          rulet += 'Drop Waitlist - '
          if (rule['id-dr']) {
            rulet += 'Drop Ids ' + rule['id-dr'] + ', '
          }
          if (rule['all']) {
            rulet += 'All ' + rule['all'] ? 'All' : 'Any'
          }
          items[i].type = 'Drop Waitlist'
        } else if (element.k === 30) {
          rulet += 'User Status - '
          if (rule['kyc-st']) {
            rulet += 'KYC Status ' + rule['kyc-st'] + ', '
          }
          if (rule['verified']) {
            rulet += 'Verified ' + rule['verified'] + ', '
          }
          if (rule['email-verified']) {
            rulet += 'Email Verified ' + rule['email-verified'] + ', '
          }
          if (rule['2fa-enabled']) {
            rulet += '2FA Enabled ' + rule['2fa-enabled'] + ', '
          }
          if (rule['2fa-type']) {
            rulet += '2FA Type ' + rule['2fa-type'] + ', '
          }
          items[i].type = 'User Status'
        }

        if (rule['ts-start'] !== undefined && rule['ts-end'] !== undefined) {
          var date1 = new moment(
            parseInt(
              rule['ts-start'].toString().substring(0, rule['ts-start'].toString().length - 3),
            ),
          ).format('L')
          var date2 = new moment(
            parseInt(rule['ts-end'].toString().substring(0, rule['ts-end'].toString().length - 3)),
          ).format('L')
          rulet += 'Time ' + date1 + ' - ' + date2
        }

        if (rule['dur-min'] !== undefined && rule['dur-max'] !== undefined) {
          rulet += 'Time ' + rule['dur-min'] + ' - ' + rule['dur-max']
        }

        if (
          rule['days-min'] !== undefined &&
          rule['days-min'] !== null &&
          rule['days-max'] !== undefined &&
          rule['days-max'] !== null
        ) {
          rulet += 'Days ' + rule['days-min'] + ' - ' + rule['days-max']
        }
        if (rule['days-min'] !== undefined && rule['days-min'] !== null && !rule['days-max']) {
          rulet += 'Days ' + rule['days-min']
        }
        if (!rule['days-min'] && rule['days-max'] !== undefined) {
          rulet += 'Days ' + rule['days-max']
        }

        items[i].rulet = rulet
      }

      vm.items = result.results
    })

    oldSortType2 = angular.copy(vm.sortType2)
    UserSegmentationService.listArchived(
      vm.oldPage1,
      15,
      vm.typeArchived,
      vm.searchArchived,
      vm.sortType2,
    ).then(function (result) {
      var items = result.results
      if (vm.totalItems1 === 0) {
        vm.totalItems1 = result.ct
      }

      for (var i = 0; i < items.length; i++) {
        var element = items[i]
        var rule = JSON.parse(element.rule)
        var rulet = ''
        if (element.k === 1) {
          rulet += 'Coin Products - '
          if (rule.all && rule['id-p'] !== undefined) {
            rulet += 'all - '
          } else if (!rule.all && rule['id-p'] !== undefined) {
            rulet += 'any - '
          }

          if (rule['id-p'] === undefined) {
            if (rule['price-min'] !== undefined) {
              rulet += 'Price min $' + rule['price-min'] + ', '
            }
            if (rule['price-max'] !== undefined) {
              rulet += 'Price max $' + rule['price-max'] + ' - '
            }
          }

          if (rule['spent-min'] !== undefined) {
            rulet += 'Spent min $' + rule['spent-min'] + ', '
          }
          if (rule['spent-max'] !== undefined) {
            rulet += 'Spent max $' + rule['spent-max'] + ' - '
          }

          if (rule['cp-min'] !== undefined) {
            rulet += 'Purchased min ' + rule['cp-min'] + ', '
          }
          if (rule['cp-max'] !== undefined) {
            rulet += 'Purchased max ' + rule['cp-max'] + ' - '
          }

          if (rule['store'] !== undefined) {
            var idsConcat = ''
            rule['store'].map(function (item) {
              var store = _.find(vm.stores, function (o) {
                return o.id === item
              })
              idsConcat += store.name + ', '
            })

            rulet += 'Store: ' + idsConcat
          }

          items[i].type = 'Product'
        } else if (element.k === 2) {
          rulet += 'Collectible Bundles - '
          if (rule.all && rule['id-b'] !== undefined) {
            rulet += 'all - '
          } else if (!rule.all && rule['id-b'] !== undefined) {
            rulet += 'any - '
          }

          if (rule['cbp-min'] !== undefined) {
            rulet += 'Purchase count min ' + rule['cbp-min'] + ', '
          }
          if (rule['cbp-max'] !== undefined) {
            rulet += 'Purchase count max ' + rule['cbp-max'] + ' - '
          }

          if (rule['spent-min'] !== undefined) {
            rulet += 'Total spent min ' + rule['spent-min'] + ', '
          }
          if (rule['spent-max'] !== undefined) {
            rulet += 'Total spent max ' + rule['spent-max'] + ' - '
          }

          if (rule['spent-min-cash'] !== undefined) {
            rulet += 'Total spent cash min ' + rule['spent-min-cash'] + ', '
          }
          if (rule['spent-max-cash'] !== undefined) {
            rulet += 'Total spent cash max ' + rule['spent-max-cash'] + ' - '
          }

          if (rule['inc-free'] !== undefined) {
            rulet += 'Include free: yes -'
          }

          items[i].type = 'Bundle'
        } else if (element.k === 3) {
          rulet += 'Sets - '

          if (rule.all && rule['id-s'] !== undefined) {
            rulet += 'all - '
          } else if (!rule.all && rule['id-s'] !== undefined) {
            rulet += 'any - '
          }

          if (rule['r-val-min'] !== undefined) {
            rulet += 'Value Rank min ' + rule['r-val-min'] + ', '
          }
          if (rule['r-val-max'] !== undefined) {
            rulet += 'Value Rank max ' + rule['r-val-max'] + ' - '
          }

          if (rule['r-comp-min'] !== undefined) {
            rulet += 'Comp Rank min ' + rule['r-comp-min'] + ', '
          }
          if (rule['r-comp-max'] !== undefined) {
            rulet += 'Comp Rank max ' + rule['r-comp-max'] + ' - '
          }

          items[i].type = 'Set'
        } else if (element.k === 5) {
          rulet += 'Promo ID ' + rule['id-promo']
          items[i].type = 'Promo'
        } else if (element.k === 6) {
          rulet += 'Users ID ' + rule['id-u']
          items[i].type = 'User'
        } else if (element.k === 7) {
          rulet += 'Cohort Count - ' + rule['c-cohort'] + ', '
          rulet += 'Cohort To Match - ' + rule.ctm
          items[i].type = 'A/B Testing'
        } else if (element.k === 8) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'And Segment IDs - ' + idsConcat
          items[i].type = 'And Segment'
        } else if (element.k === 9) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Xor Segment IDs - ' + idsConcat
          items[i].type = 'Xor Segment'
        } else if (element.k === 10) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Not Segment IDs - ' + idsConcat
          items[i].type = 'Not Segment'
        } else if (element.k === 11) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Exclude Segment IDs - ' + idsConcat
          rulet += 'Starting Segment IDs - ' + rule['id-sseg'] + ', '
          items[i].type = 'Exclude Segment'
        } else if (element.k === 13) {
          if (rule['lc-min'] !== undefined) {
            rulet += 'Listing Count Min ' + rule['lc-min'] + ', '
          }
          if (rule['lc-max'] !== undefined) {
            rulet += 'Listing Count Max ' + rule['lc-max'] + ' - '
          }
          if (rule['sc-min'] !== undefined) {
            rulet += 'Sales Count Min ' + rule['sc-min'] + ', '
          }
          if (rule['sc-max'] !== undefined) {
            rulet += 'Sale Count Max ' + rule['sc-max'] + ' - '
          }
          if (rule['sa-min'] !== undefined) {
            rulet += 'Sales Amount Min ' + rule['sa-min'] + ', '
          }
          if (rule['sa-max'] !== undefined) {
            rulet += 'Sale Amount Max ' + rule['sa-max'] + ' - '
          }
          if (rule['id-ch'] !== undefined) {
            rulet += 'Channel ID ' + rule['id-ch'] + ' - '
          }
          if (rule['id-s'] !== undefined) {
            rulet += 'Set ID ' + rule['id-s'] + ' - '
          }
          items[i].type = 'Listing'
        } else if (element.k === 14) {
          if (rule['ce-min'] !== undefined) {
            rulet += 'Coins Earned Min ' + rule['ce-min'] + ', '
          }
          if (rule['ce-max'] !== undefined) {
            rulet += 'Coins Earned Max ' + rule['ce-max'] + ' - '
          }
          if (rule['ec-min'] !== undefined) {
            rulet += 'Earned Count Min ' + rule['ec-min'] + ', '
          }
          if (rule['ec-max'] !== undefined) {
            rulet += 'Earned Count Max ' + rule['ec-max'] + ' - '
          }
          items[i].type = 'Fyber'
        } else if (element.k === 15) {
          if (rule['c-min'] !== undefined) {
            rulet += 'Coins Min ' + rule['c-min'] + ', '
          }
          if (rule['c-max'] !== undefined) {
            rulet += 'Coins Max ' + rule['c-max']
          }
          items[i].type = 'Coin Wallet'
        } else if (element.k === 16) {
          if (rule['cl-min'] !== undefined) {
            rulet += 'Claims Min ' + rule['cl-min'] + ', '
          }
          if (rule['cl-max'] !== undefined) {
            rulet += 'Claims Max ' + rule['cl-max']
          }
          if (rule['c-min'] !== undefined) {
            rulet += 'Coins Min ' + rule['c-min'] + ', '
          }
          if (rule['c-max'] !== undefined) {
            rulet += 'Coins Max ' + rule['c-max']
          }
          items[i].type = 'Coin Claim'
        } else if (element.k === 17) {
          if (rule['cpo-min'] !== undefined) {
            rulet += 'Prints Min ' + rule['cpo-min'] + ', '
          }
          if (rule['cpo-max'] !== undefined) {
            rulet += 'Prints Max ' + rule['cpo-max']
          }
          if (rule['cqo-min'] !== undefined) {
            rulet += 'Collectibles Min ' + rule['cqo-min'] + ', '
          }
          if (rule['cqo-max'] !== undefined) {
            rulet += 'Collectibles Max ' + rule['cqo-max']
          }
          items[i].type = 'Collection Size'
        } else if (element.k === 18) {
          var idsConcat = ''
          rule['id-q'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Owns Collectible IDs - ' + idsConcat
          if (rule['all'] !== undefined) {
            rulet += ' All - ' + rule['all']
          }
          items[i].type = 'Collectible Ownership'
        } else if (element.k === 19) {
          if (rule['val-min'] !== undefined) {
            rulet += 'Value Min ' + rule['val-min'] + ', '
          }
          if (rule['val-max'] !== undefined) {
            rulet += 'Value Max ' + rule['val-max']
          }
          items[i].type = 'Collection Value'
        } else if (element.k === 20) {
          var idsConcat = ''
          rule['id-seg'].map(function (item) {
            idsConcat += item + ','
          })
          rulet += 'Or Segment IDs - ' + idsConcat
          items[i].type = 'Or Segment'
        } else if (element.k === 21) {
          if (rule['id-ch'] !== undefined) {
            rulet += 'Channel ID ' + rule['id-ch']
          }
          if (rule['lcs'] !== undefined) {
            rulet += 'Locales ' + rule['lcs']
          }
          items[i].type = 'Region'
        } else if (element.k === 22) {
          if (rule['lang'] && rule['lang'].length > 0) {
            rulet += 'Languages ' + rule['lang']
          }
          if (rule['comm'] && rule['comm'].length > 0) {
            rulet += 'Communities ' + rule['comm']
          }
          items[i].type = 'Language'
        } else if (element.k === 23) {
          rulet += 'Coupon - '
          if (rule['id-cpn']) {
            rulet += 'Coupon IDs ' + rule['id-cpn'] + ', '
          }

          if (rule['cc-min']) {
            rulet += 'Count Min ' + rule['cc-min'] + ', '
          }
          if (rule['cc-max']) {
            rulet += 'Count Max ' + rule['cc-max']
          }
          items[i].type = 'Coupon'
        } else if (element.k === 24) {
          rulet += 'User Notification Preferences - '
          if (rule['met']) {
            var met = _.find(vm.notificationMethod, function (o) {
              return o.id === rule['met']
            })

            rulet += 'Method ' + met.name + ', '
          }
          if (rule['k']) {
            var kType = _.find(vm.notificationType, function (o) {
              return o.id === rule['k']
            })
            rulet += 'Type ' + kType.name + ', '
          }
          if (rule['enabled']) {
            rulet += 'Enabled ' + rule['enabled'] ? 'Yes' : 'No'
          }
          items[i].type = 'User Notification Preferences'
        } else if (element.k === 25) {
          rulet += 'Set Waitlist - '
          if (rule['id-s']) {
            rulet += 'Set Ids ' + rule['id-s'] + ', '
          }
          if (rule['all']) {
            rulet += 'All ' + rule['all'] ? 'All' : 'Any'
          }
          items[i].type = 'Set Waitlist'
        } else if (element.k === 26) {
          rulet += 'User Sign-in - '
          if (rule['cc-min']) {
            rulet += 'Count Min ' + rule['cc-min'] + ', '
          }
          if (rule['cc-max']) {
            rulet += 'Count Max ' + rule['cc-max']
          }
          if (rule['days']) {
            rulet += 'Days ' + (rule['days'] ? 'yes' : 'no') + ', '
          }
          if (rule['m']) {
            var m = _.join(
              _.flatMap(
                _.filter(vm.loginMethods, function (o) {
                  return rule['m'].indexOf(o.id) !== -1
                }),
                'name',
              ),
              ', ',
            )
            if (m) {
              rulet += 'Method ' + m + ', '
            }
          }
          if (rule['all']) {
            rulet += 'All ' + rule['all'] ? 'All' : 'Any'
          }
          items[i].type = 'User Sign-in'
        }

        if (rule['ts-start'] !== undefined && rule['ts-end'] !== undefined) {
          var date1 = new moment(
            parseInt(
              rule['ts-start'].toString().substring(0, rule['ts-start'].toString().length - 3),
            ),
          ).format('L')
          var date2 = new moment(
            parseInt(rule['ts-end'].toString().substring(0, rule['ts-end'].toString().length - 3)),
          ).format('L')
          rulet += 'Time ' + date1 + ' - ' + date2
        }

        if (rule['dur-min'] !== undefined && rule['dur-max'] !== undefined) {
          rulet += 'Time ' + rule['dur-min'] + ' - ' + rule['dur-max']
        }

        if (
          rule['days-min'] !== undefined &&
          rule['days-min'] !== null &&
          rule['days-max'] !== undefined &&
          rule['days-max'] !== null
        ) {
          rulet += 'Days ' + rule['days-min'] + ' - ' + rule['days-max']
        }
        if (rule['days-min'] !== undefined && rule['days-min'] !== null && !rule['days-max']) {
          rulet += 'Days ' + rule['days-min']
        }
        if (!rule['days-min'] && rule['days-max'] !== undefined) {
          rulet += 'Days ' + rule['days-max']
        }

        items[i].rulet = rulet
      }

      vm.itemsArchived = result.results
    })
  }

  function loadNotArchived(pageNumber) {
    load(pageNumber, false)
  }

  function loadArchived(pageNumber) {
    load(pageNumber, true)
  }

  vm.snapshotted = ''
  vm.itemSnapshots = []
  function loadSnapshots(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination3.current = 1
    }
    if (!vm.first3) {
      vm.currentPage3 = pageNumber * 15
      vm.oldPage3 = vm.currentPage3 - 15
    } else {
      vm.first3 = false
    }

    UserSegmentationService.listSnapshots(vm.oldPage3, 15, vm.snapshotted).then(function (result) {
      if (vm.totalItems3 === 0) {
        vm.totalItems3 = result.ct
      }
      for (var i = 0; i < result.results.length; i++) {
        result.results[i]['ts-m'] = new Date(result.results[i]['ts-m'] / 1000)
        result.results[i]['ts'] = new Date(result.results[i]['ts'] / 1000)
        if (result.results[i]['ts-snap'] > 0) {
          result.results[i]['ts-snap'] = new Date(result.results[i]['ts-snap'] / 1000)
        } else {
          result.results[i]['ts-snap'] = null
        }
      }
      vm.itemSnapshots = result.results
    })
  }

  loadSnapshots(1)

  vm.itemSnapshotsUnscheduled = []
  function loadSnapshotsUnscheduled(pageNumber) {
    if (pageNumber === 1) {
      vm.pagination4.current = 1
    }
    if (!vm.first4) {
      vm.currentPage4 = pageNumber * 10
      vm.oldPage4 = vm.currentPage4 - 10
    } else {
      vm.first4 = false
    }

    UserSegmentationService.listSnapshotsUnscheduled(vm.oldPage4, 10).then(function (result) {
      if (vm.totalItems4 === 0) {
        vm.totalItems4 = result.ct
      }
      for (var i = 0; i < result.results.length; i++) {
        result.results[i]['ts-m'] = new Date(result.results[i]['ts-m'] / 1000)
        result.results[i]['ts'] = new Date(result.results[i]['ts'] / 1000)
        if (result.results[i]['ts-snap'] > 0) {
          result.results[i]['ts-snap'] = new Date(result.results[i]['ts-snap'] / 1000)
        } else {
          result.results[i]['ts-snap'] = null
        }
      }
      vm.itemSnapshotsUnscheduled = result.results
    })
  }

  loadSnapshotsUnscheduled(1)

  vm.searchSegmentationActiveByText = function (event) {
    event.preventDefault()
    var isBreak = false
    for (var i = 0; i < vm.searchActive.length; i++) {
      if (vm.searchActive[i] === '%') {
        isBreak = true
      } else {
        isBreak = false
      }
    }

    if (isBreak) {
      swal('Invalid Search Character, "%" must be entered with other text.', '', 'warning')
      return
    }

    resetPage()
    vm.sortType = 'id-desc'
    vm.sortReverse = false
    load(1, false)
  }

  vm.searchSegmentationActiveByType = function () {
    resetPage()
    vm.sortType = 'id-desc'
    vm.sortReverse = false
    load(1, false)
  }

  vm.searchSegmentationArchivedByText = function (event) {
    event.preventDefault()
    var isBreak = false
    for (var i = 0; i < vm.searchArchived.length; i++) {
      if (vm.searchArchived[i] === '%') {
        isBreak = true
      } else {
        isBreak = false
      }
    }

    if (isBreak) {
      swal('Invalid Search Character, "%" must be entered with other text.', '', 'warning')
      return
    }

    vm.sortType2 = 'id-desc'
    vm.sortReverse2 = false
    resetPage1()
    load(1, true)
  }

  vm.searchSegmentationArchivedByType = function () {
    resetPage1()
    vm.sortType2 = 'id-desc'
    vm.sortReverse2 = false
    load(1, true)
  }

  vm.searchSnapshotted = function () {
    resetPage3()
    loadSnapshots(1)
  }

  vm.add = function () {
    $state.go('admin.user_segmentation.manager', { id: 0 })
  }

  vm.edit = function (item) {
    $state.go('admin.user_segmentation.manager', { id: item.id })
  }

  vm.selectSegmentation = function (pageNumber, test) {
    pageNumber = parseInt(pageNumber)
    if (pageNumber === 1) {
      resetPage2()
      vm.pagination2.current = 1
    }
    if (!vm.first2) {
      vm.currentPage2 = pageNumber * 15
      vm.oldPage2 = vm.currentPage2 - 15
    } else {
      vm.first2 = false
    }
    UserSegmentationService.listUserBySegmentation(vm.segmentationId, vm.oldPage2, 15).then(
      function (result) {
        if (vm.totalItems2 === 0) {
          vm.totalItems2 = result.ct
        }
        const items = _.sortBy(result.results, function (item) {
          return item?.leader?.r
        })
        vm.users = items
        if (vm.users === undefined || vm.users.length === 0) {
          vm.msgFilter = 'Users not found'
        }

        if (result.warning) {
          swal('Warning', result.warning.message, 'warning')
          vm.users = []
        } else {
          if (test) swal('Success', vm.totalItems2 + ' users found', 'success')
        }
      },
    )
  }

  vm.pageChanged = function (newPage) {
    vm.sortType = oldSortType
    loadNotArchived(newPage)
    loadArchived(1)
  }

  vm.pageChanged1 = function (newPage) {
    vm.sortType2 = oldSortType2
    loadArchived(newPage)
  }

  vm.pageChanged2 = function (newPage) {
    vm.selectSegmentation(newPage)
  }

  vm.pageChanged3 = function (newPage) {
    loadSnapshots(newPage)
  }

  vm.pageChanged4 = function (newPage) {
    loadSnapshotsUnscheduled(newPage)
  }

  vm.delete = function (item) {
    swal(
      {
        title: 'Any Associated products will lose this segment?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          UserSegmentationService.remove(item.id).then(function () {
            resetPage()
            resetPage1()
            vm.sortType = 'id-desc'
            vm.sortReverse = false
            vm.sortType2 = 'id-desc'
            vm.sortReverse2 = false
            loadArchived(1)
            loadNotArchived(1)
          })
        } else {
          return
        }
      },
    )
  }

  vm.clone = function (item) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to clone?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          UserSegmentationService.clone(item.id).then(function () {
            resetPage()
            resetPage1()
            vm.sortType = 'id-desc'
            vm.sortReverse = false
            vm.sortType2 = 'id-desc'
            vm.sortReverse2 = false
            loadArchived(1)
            loadNotArchived(1)
          })
        } else {
          return
        }
      },
    )
  }

  vm.archive = function (item, archived) {
    archived = Boolean(archived)
    var msg = ''
    if (archived) {
      msg = 'You really want to expire?'
    } else {
      msg = 'You really want to active?'
    }
    swal(
      {
        title: 'Are you sure?',
        text: msg,
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          UserSegmentationService.update(item.id, { arch: archived }).then(function () {
            vm.sortType = 'id-desc'
            vm.sortReverse = false
            vm.sortType2 = 'id-desc'
            vm.sortReverse2 = false
            loadArchived(vm.pagination1.current)
            loadNotArchived(vm.pagination.current)
          })
        } else {
          return
        }
      },
    )
  }

  vm.export = function () {
    if (vm.segmentationId === undefined || vm.segmentationId === null) {
      return
    }

    CsvService.validSafari()

    UserSegmentationService.listUserBySegmentationWithoutPagination(vm.segmentationId).then(
      function (result) {
        var rows = result.results
        var newList = []
        for (var i = 0; i < rows.length; i++) {
          newList.push({
            id: rows[i].id,
            username: rows[i].username === undefined ? '' : rows[i].username,
            email: rows[i].email,
            name: rows[i].name === undefined ? '' : rows[i].name,
            zip_code: rows[i].zip_code === undefined ? '' : rows[i].zip_code,
            city: rows[i].city === undefined ? '' : rows[i].city,
            state: rows[i].state === undefined ? '' : rows[i].state,
            country: rows[i].country === undefined ? '' : rows[i].country,
            address_line1: rows[i].address_line1 === undefined ? '' : rows[i].address_line1,
            address_line2: rows[i].address_line2 === undefined ? '' : rows[i].address_line2,
          })
        }
        var csv = CsvService.convertArrayOfObjectsToCSV({
          data: newList,
        })

        if (csv === null) {
          return
        }

        var pom = document.createElement('a')
        var csvContent = csv //here we load our csv data
        var blob = new Blob([csvContent], {
          type: 'text/csv;charset=utf-8;',
        })
        var url = URL.createObjectURL(blob)
        pom.href = url
        pom.setAttribute('download', 'users.csv')
        pom.click()
      },
    )
  }

  vm.showDescription = function (item) {
    $('#myModal').modal('show')
    $('#myModal').on('shown.bs.modal', function () {
      $('#description').text(item)
    })
  }

  vm.sort = function (type, isTab) {
    if (isTab === 1) {
      vm.sortReverse = !vm.sortReverse
      if (vm.sortReverse) {
        vm.sortType = type + '-asc'
      } else {
        vm.sortType = type + '-desc'
      }
      loadNotArchived(vm.pagination.current)
    } else {
      vm.sortReverse2 = !vm.sortReverse2
      if (vm.sortReverse2) {
        vm.sortType2 = type + '-asc'
      } else {
        vm.sortType2 = type + '-desc'
      }
      loadArchived(vm.pagination1.current)
    }
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }
  vm.push = function () {
    var message = angular.copy(vm.message)
    if (!message.t) {
      swal('Please enter a Text', '', 'error')
      return
    }

    if (!vm.pushAt) {
      swal('Please enter a Push at', '', 'error')
      return
    }
    if (!message.m) {
      swal('Please enter a Method', '', 'error')
      return
    }

    if (message.m) {
      message.m = message.m.join()
    }

    if (vm.pushAt) {
      if (isDate(vm.pushAt)) {
        var date = parseInt(new Date(vm.pushAt).getTime() + '000')
        message['ts-pu'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      message['ts-pu'] = null
    }

    ScheduledMessageAppService.save(message).then(
      function () {
        $('#myModalPushSegment').modal('hide')
        vm.currentSegment = null
        swal(
          'Created with success',
          'You can check this message in the scheduled message page',
          'success',
        )
      },
      function (err) {
        swal(err.error.message, '', 'error')
      },
    )
  }

  vm.isOpen2 = false
  vm.convertTimezone = function () {
    if (vm.pushAt) {
      vm.timezoneDate2PublishedNY = moment(vm.pushAt)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDate2PublishedLA = moment(vm.pushAt)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
  }
  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.currentSegment = null
  vm.modalPushSegment = function (item) {
    vm.message = {
      id: 0,
      t: '',
      k: 11,
      url: '',
      'ts-pu': null,
      'ts-x': null,
      'id-us': item.id,
    }
    vm.pushAt = null

    vm.currentSegment = item
    $('#myModalPushSegment').modal('show')
  }

  vm.searchUsers = function () {
    resetPage2()
    vm.segmentationId = parseInt($('#e15').select2('val'))
    if (!vm.segmentationId) {
      return
    }
    vm.selectSegmentation(1)
  }

  vm.testSegment = function (item) {
    vm.segmentationId = item.id
    vm.selectSegmentation(1, true)
  }

  vm.modalSearchUser = function (item) {
    vm.selectedSegment = item
    $('#myModalSearchUser').modal('show')
  }

  vm.searchModal = ''

  vm.options = [
    {
      id: 1,
      name: 'Username',
    },
    {
      id: 2,
      name: 'Email',
    },
    {
      id: 3,
      name: 'ID',
    },
  ]
  vm.option = vm.options[0].id

  reloadPaginationSearchUser()

  vm.searchModalUsers = function () {
    reloadPaginationSearchUser()
    loadUsers(1)
  }

  vm.addUser = function (item) {
    vm.userId = item.id
    UserSegmentationService.matchUserSegment(item.id, vm.selectedSegment.id).then(
      function (result) {
        swal('Match: ', result.results.match ? 'Yes' : 'No', 'success')
      },
    )
  }

  function loadUsers(pageNumber) {
    if (vm.option !== 3) {
      if (
        vm.searchModal === undefined ||
        vm.searchModal === null ||
        vm.searchModal === '' ||
        vm.searchModal.length < 3
      ) {
        return
      }
    } else {
      if (vm.searchModal === undefined || vm.searchModal === null || vm.searchModal === '') {
        return
      }
    }

    if (pageNumber === 1) {
      vm.paginationSearchUser.current = 1
    }
    if (!vm.firstSearchUser) {
      vm.currentPageSearchUser = pageNumber * 10
      vm.oldPageSearchUser = vm.currentPageSearchUser - 10
    } else {
      vm.firstSearchUser = false
    }
    vm.usersModal = []
    if (vm.option === 1) {
      UsersService.search(vm.searchModal, '', vm.oldPageSearchUser, 10).then(function (result) {
        if (vm.totalItemsSearchUser === 0) {
          vm.totalItemsSearchUser = result.ct
        }
        vm.usersModal = result.results
      })
    } else if (vm.option === 2) {
      UsersService.searchEmail(vm.searchModal, '', vm.oldPagSearchUser, 10).then(function (result) {
        if (vm.totalItemsSearchUser === 0) {
          vm.totalItemsSearchUser = result.ct
        }
        vm.usersModal = result.results
      })
    } else {
      UsersService.get(vm.searchModal).then(function (result) {
        if (vm.totalItemsSearchUser === 0) {
          vm.totalItemsSearchUser = 1
        }
        vm.usersModal = [result.results]
      })
    }
  }

  vm.loadImage = false
  vm.upload = function (item) {
    vm.loadImage = true
    UploadService.save('schedule_messages', vm.pathImg, 'image', item.id).then(function (fileName) {
      vm.loadImage = false
      item['img-t'] = `schedule_messages/${fileName}`
    })
  }

  vm.checkUnscheduled = function (item) {
    const rule = JSON.parse(item.rule)
    if ((item.k == 3 || item.k == 4 || item.k == 18) && rule['ts-end']) {
      return true
    }

    return false
  }
}
